import styled from '@emotion/native'
import { TouchableOpacity, View } from 'react-native'
import Text from '../../atoms/Text'
import Input from '../../molecules/input'

export const Container = styled(View)<{
  variant?: 'outlined' | 'underlined'
}>(({ theme, variant }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  borderColor: variant === 'outlined' ? '#e8e8e8' : '#BDBDBD',
  borderWidth: variant === 'outlined' ? 1 : 0,
  borderBottomWidth: variant === 'underlined' ? 1 : 1,
  backgroundColor: variant === 'outlined' ? '#f6f6f6' : 'transparent',
  width: '100%',
  padding: variant === 'outlined' ? theme.sizes.xs : 0 ,
  borderRadius: variant === 'outlined' ? 8 : 0, 

}))

export const DropDownContainer = styled(TouchableOpacity)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const TitlePlaceHolder = styled(Text)<{ color?: string }>(({ theme, color }) => ({
  fontSize: 14,
  color: color ?? 'grey',
}))

export const TitleSelected = styled(Text)(({ theme }) => ({
  lineHeight: theme.fontSizes.paragraph_a.lineHeight !== 0 ? theme.fontSizes.paragraph_a.lineHeight : undefined,
  letterSpacing: theme.fontSizes.paragraph_a.letterSpacing,
  // fontSize: theme.fontSizes.paragraph_a.fontSize,
  color: 'black',
}))

export const TitleModal = styled(Text)(({ theme }) => ({
  alignSelf: 'flex-start',
}))

export const InputSearch = styled(Input)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.sizes.sm,
}))
